<div class="pending-overlay" *ngIf="pending$ | async">
  <div class="pending-overlay__spinner" role="status" aria-label="Datensatz wird geladen"></div>
</div>
